export const PDFTRON_PATH = `/webviewer/${import.meta.env.VITE_PDFTRON_VERSION}`;
